<script setup lang="ts">
import type { FileSystem, FSEntry } from '~/types'

import { useVModel } from '@vueuse/core'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import Layout from '~/ui/Layout.vue'
import Button from '~/ui/Button.vue'
import Input from '~/ui/Input.vue'
import Loader from '~/ui/Loader.vue'

interface Events {
  (e: 'update:modelValue', value: string[]): void
  (e: 'import'): void
}

interface Props {
  data: FileSystem
  isLoading: boolean
  modelValue: string[]
}

const { t } = useI18n()

const emit = defineEmits<Events>()
const props = defineProps<Props>()

const value = useVModel(props, 'modelValue', emit)
const handleClick = (entry: FSEntry) => {
  if (!entry.dir) return

  if (entry.name === '..') {
    value.value.pop()
    return
  }

  value.value.push(entry.name)
}
const path = computed(() => props.data.root + '/' + value.value.join('/'))
</script>

<template>
  <div>
      <Loader   v-if="isLoading"/>
    <Layout flex>
      <Input
        v-model="path"
      />
      <Button
        class="color-primary-solid"
        @click.prevent="emit('import')"
      >
        {{ t('components.library.FsBrowser.button.import') }}
      </Button>
    </Layout>
    <div class="ui list component-fs-browser">
      <a
        v-if="value.length > 0"
        class="item"
        href=""
        @click.prevent="handleClick({ name: '..', dir: true })"
      >
        <Icon icon="bi:folder" />
        <div class="content">
          <div class="header doubledot symbol" />
        </div>
      </a>
      <a
        v-for="e in data.content"
        :key="e.name"
        class="item"
        href=""
        @click.prevent="handleClick(e)"
      >
        <Icon :icon="e.dir ? 'bi:folder' : 'bi:file-earmark-music-fill'" />
        <div class="content">
          <div class="header">{{ e.name }}</div>
        </div>
      </a>
    </div>
  </div>
</template>
